import type { BaseMenuItem, MenuDropdownItem } from 'hfs-common-ui';
import React from 'react';
import MobileMenuDropdownItem from '../MobileMenuDropdownItem/MobileMenuDropdownItem';

import * as S from './styled';

export interface Props {
  activeMenuItemId?: number;
  onClick: (menuItem: BaseMenuItem) => void;
  menu?: MenuDropdownItem[];
}
const MobileMenuDropwdown = ({ menu, activeMenuItemId, onClick }: Props) => {
  return (
    <S.NavMenu>
      {menu?.map((item) => (
        <MobileMenuDropdownItem
          selected={item.id === activeMenuItemId}
          onClick={onClick}
          menuItem={item}
          key={item.id}
        />
      ))}
    </S.NavMenu>
  );
};

export default MobileMenuDropwdown;
